<template>

  <Toast baseZIndex="1000000"/>

  <div class="border-layout">
    <div v-if="authenticated">
      <TabMenu :model="items"/>
    </div>
    <div>
      <router-view />
    </div>
  </div>
  <div v-if="authenticated" id="log-out">
    <Button label="Изход" class="p-button-danger" @click="onLogout" />
  </div>

</template>

<script>

export default {
  data() {
    const authenticated = localStorage.getItem("authenticated") === "true";
    return {
      items: [
        // {label: 'Home', icon: 'pi pi-fw pi-home', to: '/'},
        {label: 'Контрагенти', icon: 'pi pi-fw pi-calendar', to: '/contragents'},
        // {label: 'Търговски обекти', icon: 'pi pi-fw pi-calendar', to: '/stores'},
        {label: 'Продукти', icon: 'pi pi-fw pi-calendar', to: '/products'},
        {label: 'Доставки', icon: 'pi pi-fw pi-calendar', to: '/deliveries'},
        {label: 'Продажби', icon: 'pi pi-fw pi-shopping-cart', to: '/sales'},
        {label: 'Изписване на стока', icon: 'pi pi-fw pi-flag', to: '/consumptions'},
        {label: 'Стоков оборот', icon: 'pi pi-book', to: '/stock-turnover'},
        {label: 'Справка продажби по артикули', icon: 'pi pi-money-bill', to: '/stock-sales'},
      ],
      authenticated: authenticated,
      visible: false,
      data : {
        product: {
          code: '',
          name: '',
          manufacturer: '',
          varP: 20
        },
        selected: null
      },
      version: process.env.VUE_APP_VERSION,
    }
  },

  created() {
    this.$router.beforeEach((to, from, next) => {
      if (to.name !== 'login' && !this.authenticated) {
        next({ name: 'login' })
      } else if (to.name == 'login' && this.authenticated) {
        next({ path: '/' })
      } else {
        next()
      }
    })
    this.$emitter.on('logged-in', () => {
      this.authenticated = true
      this.$router.push({path:'/'})
    })
    this.$emitter.on('logged-out', () => {
      this.authenticated = false
      this.$router.push({name:'login'})
    })

  },

  methods: {
    onClick() {
      this.visible = true;
    },
    onLogout() {
      this.$emitter.emit('logged-out', true)
    },
    onSelect(data) {
      this.selected = data;
    }
  },
  computed: {
  }
}

</script>

<style>

@media screen {
  #app, html, body {
    font-family: Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    font-size: 13px;
    height: 100%;
    margin: 0;
    overflow: hidden;
    padding: 0;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: stretch;
    align-content: stretch;
  }

  #app {
  }

  .border-layout {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow: hidden;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: stretch;
    align-content: stretch;
    flex-grow: 400000;
  }
  .border-layout > :last-child {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex-grow: 400000;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
  }
  .table-header h3 {
    margin: 0;
    padding: 0;
    vertical-aligh: middle;
  }
  .scrollable {
    overflow-y: scroll !important;
    overflow-x: hidden;
  }
  .p-datatable th {
    text-align: center !important;
  }
  .p-datatable-thead .p-column-header-content {
    flex-direction: column;
  }
  .p-datatable-scrollable .p-datatable-thead > tr > th, .p-datatable-scrollable .p-datatable-tbody > tr > td, .p-datatable-scrollable .p-datatable-tfoot > tr > td {
      display: block !important;
  }
  .p-datepicker table {
    font-size: 11px;
    margin: 0;
  }
  .report-body {
      padding: 1em;
  }
  .rpt table, .rpt table td, .rpt table th {
    border-color: #e9ecef;
    color: #495057;
  }
  #log-out {
    position: absolute;
    top: 0.3em; right: 2em;
  }
}
.rpt table th {
  background-color: #f8f9fa;
}
.left {
  text-align: left !important;
}
.right {
  text-align: right !important;
}
.center {
  text-align: center !important;
}

@media print {
  .border-layout > *, .p-toolbar {
    display: none !important;
    overflow: hidden;
  }
  .border-layout > :last-child {
    display: block !important;
  }
  .border-layout .border-layout {
    overflow: hidden !important;
    display: block;
    overflow-y: scroll;
  }
  .report-body {
    display: block !important;
    overflow: hidden !important;
  }
  .report-body > .rpt > div {
    margin: 1px auto;
    display: relative;
  }
  #app, html, body {
    font-family: Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    font-size: 9px;
  }
  #log-out {
    display: none;
  }
  @page {
    margin: 1cm 1cm 1cm 3cm;
    size: A4 landscape;
  }
}

</style>
